import { useEffect, useState } from "react";
import { Text, Loader } from "@mantine/core";
import { useAuthUser } from "react-auth-kit";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import RemoteSelect2 from "./remoteSelect2";
import { CommissionScheduleProductCard } from "./commissionScheduleProductList";

const ProviderCommissionScheduleTab = ({
  form,
  provider,
  version = "COMPANY",
  showGrossRateOnly = false,
  rateFactor: rateFactorProp = 1,
}) => {
  const providerId = provider?._id ?? form?.values?._id;
  const [api] = useServerApi();
  const auth = useAuthUser();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [actualRateFactor, setActualRateFactor] = useState(rateFactorProp);

  const fetchSchedules = async () => {
    if (!providerId) return;
    try {
      setLoading(true);
      const result =
        await api.Provider.getCurrentCommissionScheduleProductList(providerId);
      setSchedules(result ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchedules();
  }, [providerId]);

  useEffect(() => {
    const setActualRateByConsultant = async () => {
      if (!auth()?.id) {
        setActualRateFactor(0);
        return;
      }
      const result = await api.User.getProducerRate(auth().id);
      if (!result || !result.rate) {
        setActualRateFactor(0);
        return;
      }
      setActualRateFactor(result.rate);
    };

    if (version === "COMPANY") {
      setActualRateFactor(rateFactorProp);
    } else {
      setActualRateByConsultant();
    }
  }, [version, auth()?.id, rateFactorProp]);

  const filteredSchedules = selectedProduct
    ? schedules.filter((schedule) => {
        const productId = schedule.product?._id ?? schedule.product;
        return String(productId) === String(selectedProduct);
      })
    : schedules;

  if (!providerId) {
    return null;
  }

  return (
    <>
      <RemoteSelect2
        apiEntity="product"
        select="code name cname _id"
        pageSize={200}
        label="Search By Product"
        size="xs"
        searchFields={["code", "name", "cname"]}
        valueField="_id"
        labelField="code"
        labelRender={(data) =>
          `[${data.code ?? ""}] ${data.name ?? ""} ${data.cname ?? ""}`
        }
        preQuery={{ provider: providerId }}
        onDataChange={(data) => {
          setSelectedProduct(data?._id ?? null);
        }}
        clearable={true}
        sort={{ by: "code", order: "asc" }}
      />

      {loading ? (
        <Loader size="xs" mt="md" />
      ) : _.isEmpty(filteredSchedules) ? (
        <Text size="sm" color="dimmed" mt="md">
          No Commission Schedule Data
        </Text>
      ) : (
        filteredSchedules.map((schedule) => (
          <CommissionScheduleProductCard
            key={schedule._id}
            scheduleProductId={schedule._id}
            showProductInfo={true}
            showCode={true}
            version={version}
            showGrossRateOnly={showGrossRateOnly}
            rateFactor={actualRateFactor}
          />
        ))
      )}
    </>
  );
};

export default ProviderCommissionScheduleTab;
